module.exports = __webpack_public_path__ + "static/media/AktivGrotesk-Regular.8a3e2352.woff";